module.exports = __webpack_public_path__ + "img/xx.6275fa5f.svg";